import { useMemo } from 'react';
import { HeroSellingPoint } from '@sapientpro/sapientpro-data-models';
import styles from './HeroSection.module.scss';
import ImagesItem, { ItemView, TImageType } from './ImagesItem';

interface IImagesBlockProps {
  items: HeroSellingPoint[];
}

type TCard = {
  type: string;
  view: string;
  item: HeroSellingPoint;
};

const ImagesBlock = ({ items }: IImagesBlockProps) => {
  const cards: TCard[] = useMemo(() => {
    const reducedCards = items.reduce<{ imagesCount: number; textItemsCount: number; cards: TCard[]; }>((result, item) => {
      let type = 'textOnly';
      let view = 'right';
      let newImagesCount = result.imagesCount;
      let newTextItemsCount = result.textItemsCount;

      const isWithImages = item.media?.length;

      if (isWithImages) {
        if (result.imagesCount === 1) {
          type = 'large';
        } else {
          type = 'small';
          view = !result.imagesCount ? 'right' : 'left';
        }

        newImagesCount += 1;
      } else {
        view = !result.textItemsCount ? 'secondary' : 'primary';

        newTextItemsCount += 1;
      }

      return ({
        imagesCount: newImagesCount,
        textItemsCount: newTextItemsCount,
        cards: [
          ...result.cards,
          {
            view,
            type,
            item,
          },
        ],
      });
    }, { imagesCount: 0, textItemsCount: 0, cards: [] });

    return reducedCards.cards;
  }, [items]);

  return (
    <div className={styles.imagesBlock}>
      {cards.map(card => (
        <ImagesItem
          key={card.item.id}
          item={card.item}
          view={card.view as ItemView}
          type={card.type as TImageType}
        />
      ))}
    </div>
  );
};

export default ImagesBlock;
